const pillars = [
  { label: 'Technology', icon: 'ri-stack-line', desc: 'Platforms, data and systems.' },
  { label: 'Research', icon: 'ri-search-line', desc: 'Evidence from the field.' },
  { label: 'Strategy', icon: 'ri-compass-3-line', desc: 'The right plan, designed.' },
  { label: 'Communication', icon: 'ri-chat-voice-line', desc: 'Narratives that move people.' },
];

export default function About() {
  return (
    <section id="about" className="relative w-full bg-background-50 py-20 md:py-28 overflow-hidden">
      <div className="px-6 md:px-16 lg:px-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div data-reveal="scale" className="relative order-2 lg:order-1">
            <div className="relative w-full aspect-[4/3] rounded-[24px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20abstract%20photograph%20of%20a%20warm%20collaborative%20workspace%20scene%20with%20maps%2C%20data%20charts%20and%20strategy%20notes%20spread%20across%20a%20large%20wooden%20table%2C%20soft%20morning%20light%20through%20windows%2C%20deep%20emerald%20green%20and%20amber%20tones%2C%20thoughtful%20institutional%20mood%2C%20no%20text%20no%20people%20no%20logos&width=1100&height=840&seq=prabhaw-about-2026&orientation=landscape"
                alt="The Prabhaw approach in practice"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/40 to-transparent"></div>
              {/* Floating badge */}
              <div className="absolute bottom-4 left-4 right-4 md:left-6 md:right-6 rounded-xl border border-background-200/80 bg-background-50/95 backdrop-blur px-5 py-4 shadow-sm">
                <p className="font-deva text-2xl text-primary-700 leading-none">प्रभाव</p>
                <p className="text-[13px] text-foreground-700 mt-1.5 leading-relaxed">
                  Technology + Research + Strategy + Communication — one integrated venture.
                </p>
              </div>
            </div>
          </div>

          {/* Copy */}
          <div className="order-1 lg:order-2">
            <div className="flex items-center gap-3 mb-4">
              <span className="text-[10px] tracking-[0.3em] uppercase text-foreground-500 font-mono">08 / About Prabhaw</span>
            </div>
            <h2 data-reveal className="text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.1] text-foreground-950 tracking-tight font-semibold">
              <span className="font-deva text-primary-700">प्रभाव</span> is not just what we say.
              <br />
              It is what our work creates.
            </h2>
            <p data-reveal="fade" style={{ ['--reveal-delay' as never]: '120ms' }} className="mt-6 max-w-lg text-[15px] md:text-base leading-[1.8] text-foreground-600">
              Prabhaw is a joint venture built to solve complex public challenges. We
              fuse the technology and execution capability of{' '}
              <strong className="text-foreground-900">XPEC Innovations</strong> with
              the survey, research, strategy and stakeholder capability of{' '}
              <strong className="text-foreground-900">NKPR Promotion</strong>.
            </p>
            <p data-reveal="fade" style={{ ['--reveal-delay' as never]: '200ms' }} className="mt-4 max-w-lg text-[15px] leading-[1.8] text-foreground-600">
              The result is an organisation that understands complex public
              challenges, transforms intelligence into strategy, and turns strategy
              into measurable impact.
            </p>

            <div data-reveal-stagger className="mt-8 grid grid-cols-2 gap-3">
              {pillars.map((p) => (
                <div key={p.label} className="stagger-child flex items-center gap-3 rounded-lg border border-background-200 bg-background-100/50 px-4 py-3.5">
                  <span className="w-10 h-10 rounded-md bg-primary-100 flex items-center justify-center text-primary-700 shrink-0">
                    <i className={`${p.icon} w-5 h-5 flex items-center justify-center`}></i>
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{p.label}</p>
                    <p className="text-[11px] text-foreground-500">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}